import { render } from "./StatBlock.vue?vue&type=template&id=3302434e&scoped=true"
import script from "./StatBlock.vue?vue&type=script&lang=js"
export * from "./StatBlock.vue?vue&type=script&lang=js"

import "./StatBlock.vue?vue&type=style&index=0&id=3302434e&scoped=true&lang=css"

import exportComponent from "C:\\Program Files\\Jenkins\\.jenkins\\workspace\\Статистика приема\\Univeris.AdmissionStatistics.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3302434e"]])

export default __exports__